export default () => ({
  categories: [],
})
